import { useQuery } from "@tanstack/react-query";
import { getThirdPartyContract } from "../../services/pdmApi.service";

export function useThirdPartyContractDetails(
  contractId: string | null,
  open: boolean,
) {
  return useQuery({
    queryKey: ["thirdPartyContract", contractId],
    queryFn: () => getThirdPartyContract(contractId as string),
    enabled: open && Boolean(contractId),
  });
}
